import Swal from "sweetalert2";

export default {
    methods: {
        showSwal(options) {
            new Swal({
                toast: true,
                position: "top-right",
                iconColor: "white",
                width: options.width ? options.width : 300,
                text: options.message,
                customClass: {
                    popup: options.type === "success" ? "bg-success" : "bg-danger",
                    htmlContainer: 'text-white',
                },
                showConfirmButton: false,
                showCloseButton: true,
                timer: 2000,
                timerProgressBar: true,
            });
        },
        showSuccessMessage(message) {
            this.showSwal({
                type: "success",
                message: message
            });
        },
        showErrorMessage(message) {
            this.showSwal({
                type: "error",
                message: message
            });
        },
        async showConfirmationSwal(options) {
            const result = await Swal.fire({
                title: options.title || "Are you sure?",
                text: options.html ? undefined : (options.text || "You won't be able to revert this!"),
                html: options.html,
                icon: options.type || "warning",
                showCancelButton: options.showCancelButton || true,
                confirmButtonText: options.confirmButtonText || "Yes, delete it!",
                cancelButtonText: options.cancelButtonText || "No, cancel!",
                reverseButtons: options.reverseButtons || true,
                preConfirm: options.preConfirm,
                didOpen: options.didOpen,
                customClass: {
                    confirmButton: "btn bg-gradient-success",
                    cancelButton: "btn bg-gradient-danger",
                    ...options.customClass,
                },
                buttonsStyling: false,
            });
            return result;
        },
        showSwalConfirmationDelete() {
            // Return a Swal mixin so callers can call `.fire()` and get a Promise
            const swalDelete = Swal.mixin({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel!",
                reverseButtons: true,
                customClass: {
                    confirmButton: "btn bg-gradient-success",
                    cancelButton: "btn bg-gradient-danger",
                },
                buttonsStyling: false,
            });

            return swalDelete;
        },
    }
};
